import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Address  {
    _originalTypeClassName = "zSHR.BO.Address";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Address.translate = translateService;
}
this.Id = null;
this.StreetName = null;
this.StreetNumber = null;
this.PostalCode = null;
this.City = null;
this.ExtraInfo = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
StreetName:any;
StreetNumber:any;
PostalCode:any;
City:any;
ExtraInfo:any;
Region:any;
Country:any;
static setRegion = ($this, value) => {
var oldValue = $this.Region;
$this.Region = value;
if (value != null) {
}
}
static setCountry = ($this, value) => {
var oldValue = $this.Country;
$this.Country = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}